module.exports = __webpack_public_path__ + "img/storybookdesign.46d3bbd6.png";